import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { buildEurCashoutDraft } from '../cashout-draft-builders';
import { CashoutDraft } from '../cashout-currency.types';
import {
  setClearJunctionPayeeType,
  setDefaultEurBankByPriority,
  setupEurCashoutForm,
} from './eur-form.logic';

@Component({
  selector: 'app-eur-form',
  templateUrl: './eur-form.component.html',
  styleUrl: '../../add-cashout.component.scss',
})
export class EurFormComponent implements OnInit {
  @Input() ctx!: any;
  @Output() draftReady = new EventEmitter<CashoutDraft>();

  ngOnInit(): void {
    setupEurCashoutForm(this.ctx);
  }

  setDefaultBankByPriority(): void {
    setDefaultEurBankByPriority(this.ctx);
  }

  setClearJunctionPayeeType(type: 'individual' | 'corporate'): void {
    setClearJunctionPayeeType(this.ctx, type);
  }

  saveTransaction(): void {
    const draft = buildEurCashoutDraft(this.ctx);
    if (draft) {
      this.draftReady.emit(draft);
    }
  }
}
